import { render } from "./UpdateContactNumberContainer.vue?vue&type=template&id=0bdd9631"
import script from "./UpdateContactNumberContainer.vue?vue&type=script&lang=js"
export * from "./UpdateContactNumberContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__